import { Image } from "@chakra-ui/react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

type Slide = { image: string };

interface IImageSlider {
  slides: Slide[];
}

const ImageSlider = ({ slides }: IImageSlider) => {
  return (
    <Carousel infiniteLoop showArrows>
      {slides.map((slide) => {
        return <Image src={slide.image} height="auto" width="800px" />;
      })}
    </Carousel>
  );
};

export default ImageSlider;
